import o from "@mui/joy/Autocomplete";
import { withBaseSelectStyle as t } from "./BaseSelect.js";
const e = t(o);
export {
  e as BaseAutocomplete
};
//# sourceMappingURL=BaseAutocomplete.js.map
